module.exports = __webpack_public_path__ + "img/LinksThumbnail.1ffe9ca3.svg";